import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { toColor } from '../../../utils/ColorTransformator'
import { mapItemToPrice } from '../../../utils/Money'

export default function(formValues: ICreateReservationFormValues): any {
  if (!formValues) {
    return null
  }

  /* eslint-disable @typescript-eslint/camelcase */
  return {
    additionalServices: formValues.services
      ? formValues.services.map(service => ({
          first_tax: service.tax,
          price: service.price
            ? service.price.toString().replace(',', '.')
            : '0.00',
          second_tax: service.secondTax,
          service_name: service.name,
        }))
      : undefined,
    adults: formValues.adultsCount,
    arrivalTime: formValues.timeFrom,
    booking: undefined,
    bookingId: undefined,
    company: formValues.company
      ? {
          city: formValues.company.city,
          country: formValues.company.country,
          name: formValues.company.name,
          postCode: formValues.company.postCode,
          street: formValues.company.street,
          vatId: formValues.company.vatId,
        }
      : null,
    customColor: toColor(formValues.customColor || '#000000'),
    dateToPay: formValues.timeToPayDate,
    dateToPayAfterStart: formValues.timeToWaitDate,
    departureTime: formValues.timeTo,
    deposit: mapItemToPrice(formValues.deposit),
    doorCode: formValues.doorCode,
    doubleBed: formValues.twinBeds ? formValues.twinBeds.toString() : '',
    finishDate: formValues.dateTo,
    guest: formValues.guest
      ? {
          apartmentNumber: formValues.guest.apartmentNumber,
          city: formValues.guest.city,
          country: formValues.guest.country,
          email: formValues.guest.email,
          houseNumber: formValues.guest.houseNumber,
          idCard: formValues.guest.idCard,
          name: formValues.guest.name,
          passport: formValues.guest.passport,
          phone: formValues.guest.phone,
          postCode: formValues.guest.postCode,
          street: formValues.guest.street,
        }
      : {},
    iCalendar: undefined,
    iCalendarId: undefined,
    id: undefined,
    isPast: undefined,
    kids: formValues.childrenCount,
    kidsAge: formValues.children.map(child => child.age.toString()),
    localTax: mapItemToPrice(formValues.localTax),
    localTaxIncluded: formValues.withoutTax,
    notes: formValues.note,
    paymentOnPlace: mapItemToPrice(formValues.endPrice).subtract(
      mapItemToPrice(formValues.advancePaymentPrice),
    ),
    paymentOnPlaceDate: formValues.payOnPlaceDate,
    paymentOnPlaceMethod: formValues.payOnPlacePaymentType,
    prepaidType: formValues.prepaidType,
    price: mapItemToPrice(formValues.endPrice),
    pricePerDay: mapItemToPrice(formValues.pricePerDay),
    provenance: formValues.provenances,
    provision: mapItemToPrice(formValues.advancePaymentPrice),
    provisionDate: formValues.advancePriceDate,
    provisionMethod: formValues.advancePaymentType,
    registration: formValues.registration,
    roomId: formValues.roomId,
    roomMates: formValues.additionalGuests.map(guest => ({
      apartmentNumber: guest.apartmentNumber,
      city: guest.city,
      country: guest.country,
      email: guest.email,
      houseNumber: guest.houseNumber,
      idCard: guest.idCard,
      name: guest.name,
      passport: guest.passport,
      phone: guest.phone,
      postCode: guest.postCode,
      street: guest.street,
    })),
    service: formValues.feeding,
    singleBed: formValues.singleBeds ? formValues.singleBeds.toString() : '',
    stage: formValues.reservationStatus,
    startDate: formValues.dateFrom,
  }
  /* eslint-enable */
}
